/**
 * Run each file through `uploadOne` strictly one at a time, in order.
 *
 * Replaces the previous `Promise.all` fan-out (PSTUDIO-3173): the backend
 * upload endpoints do a read-modify-write of the version's nodes/manifest, so
 * concurrent uploads race and the last response overwrites the rest.
 *
 * The loop awaits each call before starting the next, so the caller picks the
 * error policy via `uploadOne`'s settlement:
 * - resolve-on-error (action-file upload) → a failed file does NOT abort the
 *   rest; every file is attempted.
 * - reject-on-error (CSV import) → the rejection propagates and the loop stops;
 *   remaining files are NOT started (fail-fast / atomic).
 */
export const uploadFilesSequentially = async (
  files: File[],
  uploadOne: (file: File, index: number) => Promise<void>
): Promise<void> => {
  for (let index = 0; index < files.length; index += 1) {
    // eslint-disable-next-line no-await-in-loop -- sequential by design (PSTUDIO-3173)
    await uploadOne(files[index], index);
  }
};
